export default "__VITE_ASSET__Dq6L6Tvc__"